import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container my-25 max-w-[1312px] max-md:my-15',
    header: 'mb-8 flex gap-18',
    title: 'heading-3xl-desk max-md:heading-3xl mb-4',
    description: 'heading-l-block max-md:heading-m-block',
    headerButton: 'max-lg:hidden',
    mobileButton: 'max-xs:w-full mt-12 lg:hidden',
    steps:
      'grid grid-cols-[1fr_1fr_344px_326px] gap-4 max-2xl:grid-cols-[0.5fr_1fr_344px_1fr] max-xl:grid-cols-2 max-md:grid-cols-1',
    step: 'bg-bg-items-white relative flex cursor-pointer items-center gap-5 rounded-full p-2 pr-5 text-left lg:gap-1',
    stepIcon:
      'relative size-15 shrink-0 overflow-hidden rounded-full max-sm:size-15 lg:mr-3',
    stepDescription: 'heading-s grow',
    //soonStepBackground: 'absolute inset-0',
    stepArrow: '',
    soonStepText:
      'heading-xs bg-yellow-naos mb-0.5 flex h-4 w-fit items-center overflow-hidden rounded-full px-1 pt-1 pb-1.5'
  },
  variants: {
    soon: {
      true: {
        step: 'pointer-events-none border border-dashed border-[#CDD4D7] bg-white',
        stepIcon: 'bg-bg-items-white',
        stepArrow: 'hidden'
      }
    }
  },
  defaultVariants: {
    soon: false
  }
});
